import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "options"];
import { Label } from './CheckboxOption';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Select = _ref => {
  var {
      children,
      options = []
    } = _ref,
    other = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Label, {
    children: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx("select", _extends({}, other, {
        children: options.map((item, key) => {
          var label = (item == null ? void 0 : item.label) || item;
          var value = (item == null ? void 0 : item.value) || item;
          return /*#__PURE__*/_jsx("option", {
            value: value,
            children: label
          }, key + " " + (value || ''));
        })
      })), /*#__PURE__*/_jsx("span", {
        children: children
      })]
    })
  });
};